export default "__VITE_ASSET__MVnL_$u4__"